import React, { useEffect, useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Button from "../reusable/button"
import { window, document } from "browser-monads"
import DifficultyExplanationMenuSlider from "@src/components/menu-sliders/difficulty-explanation-menu-slider"
import ActivitiesExplanationMenuSlider from "@src/components/menu-sliders/activities-explanation-menu-slider"
import TripTypeExplanationMenuSlider from "@src/components/menu-sliders/trip-type-explanation-menu-slider"
import Currency from "@src/components/indy-tour-page/core-value-local-currency-v2"
import { PricePropTypes } from "@src/graphql-fragments/prices"
import { ImagePropTypes } from "../core-image"
const InfoSideMenueHolder = styled.div`
  display: flex;
  flex-direction: column;
`

const Row = styled.div`
  display: flex;

  gap: 8px;
`

const ReviewRow = styled(Row)`
  align-items: center;
  margin: 16px 0;
`

const MiscRow = styled(Row)`
  margin-bottom: 16px;
`

const UnderlineText = styled(Link)`
  color: ${props => props.theme.grayShade};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
  letter-spacing: 0.07px;
  text-decoration: ${props => (props.$underline ? "underline" : "none")};
  cursor: ${props => (props.$underline ? "pointer" : "default")};
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
`

const Underlined = styled(UnderlineText)`
  line-height: 14px;
  text-decoration: underline !important;
  margin: 0;
  cursor: pointer !important;
`

const Title = styled.h1`
  color: ${props => props.theme.blackText};
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: 40px;
  letter-spacing: 0.5px;
`

const SubTitle = styled.div`
  color: ${props => props.theme.secondary500};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-top: 8px;
`

const Mark = styled.div`
  color: ${props => props.theme.blackText};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`

const CategoryName = styled.div`
  color: ${props => props.theme.blackText};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.25px;
`

const Underline = styled.div`
  background: rgba(30, 30, 30, 0.08);
  height: 1px;
  width: 100%;
  margin: 7px 0;
  margin-bottom: 23px;
`

const Prices = styled.div`
  color: ${props => props.theme.secondary600};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 16px;
  display: block;
  @media (max-width: 500px) {
    display: none;
  }
`

const Question = styled.div`
  color: #404040;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
  margin-top: 16px;
`

const DotHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const ImageHolder = styled.div`
  position: relative;
  width: calc(100% + 32px);
  translate: -16px 0;
  img {
    width: 100%;
  }
  display: none;

  @media (max-width: 500px) {
    display: block;
  }
`

const ImageBorder = styled.div`
  width: 100%;
  height: auto;
  padding: 24px;
  padding-top: 24px;
  border-radius: 16px 16px 0px 0px;
  border-top: 1px solid #eee;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const Pricing = styled.div`
  color: ${props => props.theme.secondary600};

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;

  span {
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
  }
`

const QuoteButton = styled.span`
  display: block;
  @media (max-width: 500px) {
    display: none;
  }
`

const U = styled.u`
  cursor: pointer !important;
`

const InfoSideMenu = ({
  location,
  handleHPClick,
  title,
  subTitle,
  reviews,
  tourIcons,
  price,
  days,
  bookingURL,
  setIsQuestionOpen,
}) => {
  // eslint-disable-next-line
  const [isMobile, setIsMobile] = useState(false)
  const [isOpen, setIsOpen] = useState({})

  useEffect(() => {
    const element = document.querySelector(".zsiq_custommain")
    if (!element) {
      console.error('Element with class "zsiq_custommain" not found.')
      return
    }

    // Create an event listener that sets the flag.
    const clickListener = () => {
      console.log("Click event detected on .zsiq_custommain")
      // Remove the listener after it fires.
      element.removeEventListener("click", clickListener)
    }

    // Attach the event listener.
    element.addEventListener("click", clickListener)

    const checkMobile = () => setIsMobile(window.innerWidth <= 500)
    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  const iconToText = {
    "v2-calendar": "Season",
    "v2-footprints": "Activity",
    time2: "Duration",
    "v2-thick-Fire": "Difficulty",
    distance: "Type",
    camping: "Accommodation",
  }

  const underline = {
    "v2-footprints": 1,
    distance: 2,
    "v2-thick-Fire": 3,
  }
  return (
    <InfoSideMenueHolder>
      <MiscRow>
        <Location />{" "}
        <Underlined to={location.url} $underline={true}>
          {location.text}
        </Underlined>{" "}
        <DotHolder>
          <Dot />
        </DotHolder>
        <Prize />
        <Underlined
          as={"span"}
          onClick={() => handleHPClick()}
          $underline={true}
        >
          Happiness promise{" "}
        </Underlined>
      </MiscRow>
      <Title>{title}</Title>
      <SubTitle>{subTitle}</SubTitle>
      <ReviewRow>
        <Star /> <Mark>{reviews?.rating?.toFixed(2)}</Mark>{" "}
        <Underlined
          as={"span"}
          onClick={() => {
            const reviewTitle = document.getElementById("reviews")
            if (reviewTitle) {
              const yOffset = -100
              const y =
                reviewTitle.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset
              window.scrollTo({ top: y, behavior: "smooth" })
            }
          }}
        >{`(${reviews.total} reviews)`}</Underlined>
      </ReviewRow>
      {/* {isMobile && ( */}
      <ImageHolder>
        <ImageBorder>
          <Pricing>
            {days} from{" "}
            <span>
              <Currency
                className="sticky-cta-price"
                amount={price?.amount}
                code={price?.currency?.code}
                showAbbr="after"
                applyRounding={!price?.discount ? "auto" : false}
                discounted={!!price?.discount}
              />
            </span>
          </Pricing>
          <Button to={bookingURL} text="Easy quote" type="greenShade" />
        </ImageBorder>
      </ImageHolder>
      {/* )} */}
      {tourIcons?.map(metric => (
        <>
          <CategoryName>{iconToText[metric?.icon]}</CategoryName>
          <UnderlineText
            as="div"
            onClick={() => {
              if (underline[metric?.icon]) {
                setIsOpen({
                  index: underline[metric?.icon],
                  label: metric?.label,
                })
              }
            }}
            $underline={underline[metric?.icon]}
          >
            {metric?.label}
          </UnderlineText>
        </>
      ))}
      <DifficultyExplanationMenuSlider
        isOpen={isOpen?.index === 3}
        difficulty={isOpen?.label}
        setIsOpen={() => setIsOpen({})}
      />
      <ActivitiesExplanationMenuSlider
        isOpen={isOpen?.index === 1}
        activity={isOpen?.label}
        setIsOpen={() => setIsOpen({})}
      />
      <TripTypeExplanationMenuSlider
        isOpen={isOpen?.index === 2}
        type={isOpen?.label}
        setIsOpen={() => setIsOpen({})}
      />

      <Underline />
      <Prices>
        From{" "}
        <Currency
          className="sticky-cta-price"
          amount={price?.amount}
          code={price?.currency?.code}
          showAbbr="after"
          applyRounding={!price?.discount ? "auto" : false}
          discounted={!!price?.discount}
        />{" "}
        (
        <U
          onClick={() => {
            const datesAndPrices = document.getElementById("dates-and-prices")
            if (datesAndPrices) {
              const yOffset = -100
              const y =
                datesAndPrices.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset
              window.scrollTo({ top: y, behavior: "smooth" })
            }
          }}
        >
          see prices for this tour
        </U>
        )
      </Prices>
      <QuoteButton>
        <Button to={bookingURL} text="Get a quote" type="yellow" />
      </QuoteButton>
      <Question>Got any questions?</Question>
      <Button
        onClick={() => setIsQuestionOpen(true)}
        text="Ask a question"
        type="outlineQuestion"
      />
    </InfoSideMenueHolder>
  )
}

InfoSideMenu.propTypes = {
  location: PropTypes.object,
  handleHPClick: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  reviews: PropTypes.any,
  tourIcons: PropTypes.arrayOf(PropTypes.object),
  price: PropTypes.shape({ ...PricePropTypes }),
  image: PropTypes.shape({ ...ImagePropTypes }),
  days: PropTypes.string,
  bookingURL: PropTypes.string,
  setIsQuestionOpen: PropTypes.func,
}
export default InfoSideMenu

const Location = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6862_162)">
        <path
          d="M8.00019 0.0283203C6.23615 0.030261 4.54491 0.731837 3.29748 1.97914C2.05005 3.22644 1.34831 4.91762 1.34619 6.68165C1.34619 8.39499 2.67286 11.0763 5.28952 14.651C5.60103 15.0777 6.0089 15.4249 6.47993 15.6643C6.95096 15.9036 7.47184 16.0283 8.00019 16.0283C8.52854 16.0283 9.04943 15.9036 9.52046 15.6643C9.99149 15.4249 10.3994 15.0777 10.7109 14.651C13.3275 11.0763 14.6542 8.39499 14.6542 6.68165C14.6521 4.91762 13.9503 3.22644 12.7029 1.97914C11.4555 0.731837 9.76423 0.030261 8.00019 0.0283203ZM8.00019 9.33365C7.47277 9.33365 6.9572 9.17726 6.51867 8.88424C6.08014 8.59122 5.73835 8.17475 5.53651 7.68748C5.33468 7.20021 5.28187 6.66403 5.38476 6.14675C5.48766 5.62946 5.74163 5.15431 6.11457 4.78137C6.48751 4.40843 6.96267 4.15445 7.47995 4.05156C7.99723 3.94867 8.53341 4.00148 9.02068 4.20331C9.50795 4.40514 9.92443 4.74694 10.2174 5.18547C10.5105 5.624 10.6669 6.13957 10.6669 6.66699C10.6669 7.37423 10.3859 8.05251 9.88581 8.55261C9.38571 9.0527 8.70744 9.33365 8.00019 9.33365Z"
          fill="#3A6968"
        />
      </g>
      <defs>
        <clipPath id="clip0_6862_162">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const Prize = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6862_81)">
        <path
          d="M7.99984 10.6667C6.94501 10.6667 5.91386 10.3539 5.0368 9.76783C4.15974 9.1818 3.47615 8.34884 3.07248 7.37431C2.66881 6.39977 2.5632 5.32741 2.76898 4.29285C2.97477 3.25829 3.48272 2.30798 4.2286 1.5621C4.97448 0.816219 5.92479 0.308268 6.95936 0.102481C7.99392 -0.103307 9.06628 0.00231083 10.0408 0.405978C11.0154 0.809645 11.8483 1.49323 12.4343 2.37029C13.0204 3.24735 13.3332 4.2785 13.3332 5.33333C13.3316 6.74733 12.7692 8.10296 11.7693 9.10281C10.7695 10.1027 9.41384 10.6651 7.99984 10.6667ZM7.99984 12C6.55543 11.9993 5.1508 11.5267 3.99984 10.654V14.3333C3.99983 14.6473 4.08851 14.9549 4.25566 15.2206C4.42281 15.4864 4.66163 15.6996 4.94461 15.8356C5.2276 15.9715 5.54324 16.0248 5.85519 15.9893C6.16714 15.9538 6.4627 15.8308 6.70784 15.6347L7.79184 14.768C7.85091 14.7208 7.92425 14.6951 7.99984 14.6951C8.07543 14.6951 8.14877 14.7208 8.20784 14.768L9.29184 15.6347C9.53698 15.8308 9.83254 15.9538 10.1445 15.9893C10.4564 16.0248 10.7721 15.9715 11.0551 15.8356C11.3381 15.6996 11.5769 15.4864 11.744 15.2206C11.9112 14.9549 11.9998 14.6473 11.9998 14.3333V10.654C10.8488 11.5266 9.44423 11.9992 7.99984 12Z"
          fill="#8BBBAF"
        />
      </g>
      <defs>
        <clipPath id="clip0_6862_81">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const Star = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 17.7656L18.1875 21.4922L16.5469 14.4609L22.0078 9.75L14.8125 9.14062L12 2.50781L9.1875 9.14062L1.99219 9.75L7.45312 14.4609L5.8125 21.4922L12 17.7656Z"
        fill="#FEC51B"
      />
    </svg>
  )
}

const Dot = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="3"
      height="3"
      viewBox="0 0 3 3"
      fill="none"
    >
      <circle cx="1.5" cy="1.5" r="1.5" fill="#4F4F4F" />
    </svg>
  )
}
